<app-purchase
    (paymentSucceeded)="onPaymentCompleted($event)"
    [user]="user$ | async"
    [customer]="customer$ | async"
    [resource]="data"
></app-purchase>
